import BaseCtrl from 'edge/platform/base/BaseCtrl';

const fn = function ($scope, $state, $q, $stateParams, SearchService, ViewModelService, ModalService) {
    const ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        $scope.searchRequest = {
            searchParam: '',
            previousSearchParam: ''
        };

        $scope.searchResults = {
            accounts: [],
            policies: [],
            job: [],
        };

        $scope.accountInfos = [];
        $scope.policyInfos = [];
        $scope.jobInfos = [];

        $scope.searchCompleted = false;
        this.search($stateParams.searchParam);
    };

    ctrl.search = (searchParam) => {
        $scope.searchRequest.previousSearchParam = $scope.searchRequest.searchParam;
        $scope.searchRequest.searchParam = searchParam;
        const searchResults = SearchService.search($scope.searchRequest);
        $scope.searchResultsPromise = searchResults;

        $q.when(
            searchResults,
            (searchResult) => {
                $scope.searchResults.accounts = searchResult.accounts;
                $scope.searchResults.policies = searchResult.policies;
                $scope.searchResults.job = searchResult.job;
                populateAccountResults();
                populatePolicyResults();
                populateJobResults();
                $scope.searchCompleted = true;
            },
            (error) => {
                if(error.baseError.data == undefined ){
                    if(error.baseError.error){
                      //  ModalService.showError('gateway.views.modal.Error', 'gateway.views.search.Search Error');
                    }
                }
                else if (error.baseError.data.error) {
                    if (error.baseError.data.error.data.appErrorCode !== 609) {
                        ModalService.showError('gateway.views.modal.Error', 'gateway.views.search.Search Error');
                    }
                } else {
                    ModalService.showError('gateway.views.modal.Error', 'gateway.views.search.Search Error');
                }
                $scope.searchCompleted = true;
            }
        );
    };


    const populateAccountResults = () => {
        if ($scope.searchRequest.searchParam !== $scope.searchRequest.previousSearchParam) {
            while ($scope.accountInfos.length > 0) {
                $scope.accountInfos.pop();
            }
            //PSA Injected - DP7-GW-0001-316
            $scope.searchResults.accounts.forEach((account) => {
                if (account !== null) {
                    const accountInfo = {
                        accountNumber: '',
                        accountName: '',
                        primaryAddress: '',
                        isCommercialAccount: '',
                        isPersonalAccount: '',
                        organizationType: '',
                        producerCodes: [],
                        policySummaries: []
                    };

                    accountInfo.accountNumber = account.accountNumber;
                    accountInfo.accountName = account.accountHolder;
                    accountInfo.primaryAddress = account.accountHolderAddress;
                    //PSA Injected - DP7-GW-0001-316 - start
                    accountInfo.isCommercialAccount = account.isCommercialAccount;
                    accountInfo.isPersonalAccount = account.isPersonalAccount;
                    if(account.isCommercialAccount){
                        accountInfo.organizationType = account.organizationType_PSA;
                    }
                    //PSA Injected - DP7-GW-0001-316 - end
                    $scope.accountInfos.push(accountInfo);
                }
            });
        }
        return $scope.accountInfos;
    };


    const populatePolicyResults = () => {
        if ($scope.searchRequest.searchParam !== $scope.searchRequest.previousSearchParam) {
            while ($scope.policyInfos.length > 0) {
                $scope.policyInfos.pop();
            }

            //PSA Injected - DP7-GW-0001-316
            $scope.searchResults.policies.forEach((policy) => {
                if (angular.isDefined(policy.policyNumber)) {
                    const policyInfo = {
                        account: {
                            accountHolder: {
                                contactName: '',
                                firstName: '',
                                lastName: '',
                                prefix: ''
                            }
                        },
                        linesOfBusiness: '',
                        policyNumber: '',
                        accountNumber: '',
                        accountName: '',
                        primaryAddress: '',
                        producerCode: '',
                        isCommercialAccount: '',
                        organizationType: ''
                    };

                    policyInfo.policyNumber = policy.policyNumber;
                    policyInfo.accountNumber = policy.accountNumber;
                    if (policy.accountHolder.subtype === 'Company') {
                        policyInfo.account.accountName = policy.accountHolder.contactName;
                        //PSA Injected - DP7-GW-0001-316
                        policyInfo.isCommercialAccount = true;
                        policyInfo.organizationType = policy.accountHolder.organizationType_PSA;
                    } else if (policy.accountHolder.subtype === 'Person') {
                        policyInfo.account.accountName = `${policy.accountHolder.firstName} ${policy.accountHolder.lastName}`;
                    }
                    policyInfo.primaryAddress = policy.accountHolder.primaryAddress;
                    $scope.policyInfos.push(policyInfo);
                }
            });
        }
        return $scope.policyInfos;
    };
    //  below function has been added as part of UCWPRODENG-695
    const populateJobResults = () => {
        if ($scope.searchRequest.searchParam !== $scope.searchRequest.previousSearchParam) {
            while ($scope.jobInfos.length > 0) {
                $scope.jobInfos.pop();
            }
            $scope.searchResults.job.forEach((job) => {
                if (angular.isDefined(job.jobNumber)) {
                    const jobInfo = {
                        jobNumber: '',
                        status: ''
                    };
                    jobInfo.jobNumber = job.jobNumber
                    jobInfo.status = job.status
                    $scope.jobInfos.push(jobInfo);
                }
            });
        }
        return $scope.jobInfos;
    };
    return ctrl.create($scope);
};

fn.$inject = ['$scope', '$state', '$q', '$stateParams', 'SearchService', 'ViewModelService', 'ModalService'];
export default fn;
